<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <div class="widget-title">
                            <h3>Blog Kategorisi Ekle</h3>
                        </div>
                        <div class="row">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Kategori Başlığı</label>
                                    <input type="text" v-model="title" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="slug">SEF Link</label>
                                    <input type="text" v-model="slug" class="form-control custom-input">
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for></label>
                                    <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                title: "",
                api: "blog_categories"
            };
        },
        mounted() {
        },
        methods: {
            addData() {
                this.$Progress.start();
                this.axios
                    .post(this.api, {
                        title: this.title || '',
                        slug: this.slug || ''
                    })
                    .then(response => {
                        if (response.status == 201) {
                            this.$router.push({
                                name: "blog_categories.update",
                                params: {id: response.data.id}
                            });
                        }
                    });
            },
        },
        computed: {
            slug() {
                let slug = window.Slug(this.title.toLowerCase())
                return slug
            }
        }
    };
</script>

<style scoped>
</style>
